import axios from 'axios'
import router from '@/router'
import store from '@/store'
import Cookies from 'js-cookie'

/**
 * axios攔截器
 * 發送請求寫入專案相關設定，並透過vuex切換資料讀取狀態為true(配合v-loading)
 * 請求回應或失敗時也透過vuex切換資料讀取狀態為false(配合v-loading)
 */
axios.interceptors.request.use(
  config => {
    // config.timeout = 5000
    config.baseURL = process.env.remoteUrls.ERP
    config.headers.remoteSystem = 'QP'
    config.headers.Authorization = `Bearer ${Cookies.get('qp_access_token')}`
    // store.dispatch('root/setDataLoading', true)
    return config
  },
  error => {
    // @TODO: 暫時移除loading延遲
    // setTimeout(() => store.dispatch('root/setDataLoading', false), 500)
    store.dispatch('root/setDataLoading', false)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  res => {
    store.dispatch('root/setDataLoading', false)
    if (res.data.success === false && router.currentRoute.name !== 'Login') {
      // 如果API回應失敗，則判斷token失效，要求重新登入
      store.dispatch('root/systemLogout', '登入時效已過期，請重新登入')
    }
    if (res.status !== 200) {
      return Promise.reject(res)
    }
    return res
  },
  error => {
    store.dispatch('root/setDataLoading', false)
    if (error.response.status === 401 && router.currentRoute.name !== 'Login') {
      // 如果API回應401無權限，則要求重新登入
      store.dispatch('root/systemLogout', '登入驗證錯誤，請重新登入')
    }
    return Promise.reject(error)
  }
)

export default axios
